import script from "./AdminNav.vue?vue&type=script&setup=true&lang=js"
export * from "./AdminNav.vue?vue&type=script&setup=true&lang=js"

import "./AdminNav.vue?vue&type=style&index=0&id=4785c96c&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-4785c96c"]])

export default __exports__